export default __webpack_public_path__ + "static/rise-07ac039a615d573c9a18df159d403a33.svg";